import React, { useContext, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, NavLink } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { AuthContext } from "../context/UserContext";
import { Image, Tooltip } from "react-bootstrap";
import DarkModeToggle from "react-dark-mode-toggle";
import { FaBookReader, FaUser } from "react-icons/fa";

const Header = () => {
  const { user, logOut } = useContext(AuthContext);
  // const {photoURL} = user;
  console.log(user?.photoURL);

  const out = () => {
    logOut()
      .then(() => {})
      .catch((error) => console.error(error));
  };

  const [isDarkMode, setIsDarkMode] = useState(() => false);

  return (
    <div className="sticky-top">
      <Navbar collapseOnSelect expand="lg" bg="" variant="" className="hd-bg">
        {/* <Container> */}
          <Navbar.Brand href="/">

            <h2 className="ms-5 text-course fw-bold"><span className="mt-3 pt-3"><FaBookReader className="me-3"></FaBookReader></span>Schooling</h2>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" className="pt-3">
            <Nav className="me-auto ">
              <Nav.Link as={Link} to="/courses">
                <h5 className="style ">Courses</h5>
              </Nav.Link>
              <Nav.Link as={Link} to="/faq">
                <h5 className="style">FAQ</h5>
              </Nav.Link>
              <Nav.Link as={Link} to="/blog">
                <h5 className="style">Blog</h5>
              </Nav.Link>
            </Nav>
            <Nav>

            {user?.photoURL ? (
              <div className="">
                 <Image
                  src={user?.photoURL}
                  style={{ height: "40px" ,width: "40px"}}
                 
                  data-bs-toggle="tooltip" 
                  data-bs-placement="bottom"
                  title={user?.displayName}
                  className="ms-3 img-fluid img-thumbnail"
                  roundedCircle
                ></Image>
              </div>
               
              ) : (
                <FaUser className="ms-3 text-white fs-1"></FaUser>
              )}



              {user?.uid ? (
                <Button
                  onClick={out}
                  className="text-white ms-3 "
                  variant="danger"
                >
                  Log Out
                </Button>
              ) : (
                <Link to="/logIn">
                  <Button className="text-white ms-3" variant="danger">
                    Log In
                  </Button>
                </Link>
              )}
              
              <DarkModeToggle
                onChange={setIsDarkMode}
                checked={isDarkMode}
                size={80}
                className='ms-3 me-3'
              />
            </Nav>
          </Navbar.Collapse>
        {/* </Container> */}
      </Navbar>
    </div>
  );
};

export default Header;
